import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <div className="copyright">
                <div className="container">
                    <div className="row">
                        {/* <div className="col-md-4 col-xs-12 my-auto">
                        <div className="footer-logo align-middle">
                            <img src="assets/img/logo-light.png" alt="footer-logo" />
                        </div>
                    </div> */}
                        {/* <div className="col-lg-4 col-md-4 col-xs-12">
                        <div className="social-icon text-center">
                            <a className="facebook" href="#"><i className="lni-facebook-filled"></i></a>
                            <a className="twitter" href="#"><i className="lni-twitter-filled"></i></a>
                            <a className="instagram" href="#"><i className="lni-instagram-filled"></i></a>
                            <a className="linkedin" href="#"><i className="lni-linkedin-filled"></i></a>
                        </div>
                    </div> */}
                        <div className="col-md-12 col-xs-12 text-center">
                            <p className="text-center">© 2021 appXcube | Powered by <a href="https://ezfinanz.com/" rel="nofollow">Sai Roshni Capital Pvt Ltd</a></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer


// WEBPACK FOOTER //
// ./src/layouts/Footer.js